// extracted by mini-css-extract-plugin
export default {"fullWidth":"sn-z","image":"tn-z","lazyLoadPicture":"un-z","lazyLoadSpinner":"vn-z","lazyLoadSpin":"wn-z","lazyLoadImage":"xn-z","hasStyledAspectRatio":"yn-z"};